module.exports = __webpack_public_path__ + "img/31ne.b4d6878d.svg";